module.exports = __webpack_public_path__ + "static/peugeot-79fa175c12e5a3ad814fb117f4003d3e.svg";